import { createContext } from 'react'

const context = createContext('configureDiscussion')

export default context